import Moment from 'moment';

export function showDate(dateTimeStr: string) {
    if (!dateTimeStr) return "";
    return Moment(dateTimeStr).format("DD/MM/yyy");
}
export function showTime(dateTimeStr: string, showSecond: boolean) {
    if (!dateTimeStr) return "";
    const format = showSecond ? "HH:mm:ss" : "HH:mm";
    return Moment(dateTimeStr).format(format);
}
export function showAll(dateTimeStr?: string, showSecond?: boolean) {
    if (!dateTimeStr) return "";
    const format = showSecond ? "DD/MM/yyy HH:mm:ss" : "DD/MM/yyy HH:mm";
    return Moment(dateTimeStr).format(format);
}